<template>
  <b-row>
    <b-col cols="8" class="container">
      <b-row>
        <LeftTab
          :complaintData="complaintData"
          @onComplaintBtnCancelClicked="onComplaintBtnCancelClicked"
          :IsAllowDelete_PersonDataDigital="false"
          :IsReadOnly_PersonDataDigital="false"
          :personals="personals"
          :attorneys="attorneys"
          @onPersonDigitalEditClicked="onPersonDigitalEditClicked"
          @company-digital-modal-clicked="companyModalClicked"
          :IsEdit_CompanyDetail="false"
          :IsDeleteAble_CompanyDetail="false"
          :IsReadOnly_CompanyDetail="true"
          :IsEdit_CompanySearch="true"
          :complainantCompany="complainantCompany"
          @onBtnCompanySearchClicked="onBtnCompanySearchClicked"
          @onBtnCompanySearchDeleteClicked="onBtnCompanySearchDeleteClicked"
          :IsReadOnly_ComplaintDetail="false"
          :complaintDetail="complaintDetail"
          :complaintCatagoryDetail="complaintCatagoryDetail"
          :complaintDetailMultiSelect="complaintDetailMultiSelect"
          :company="complaintData"
          @checkboxChanged="checkboxChanged"
          :IsEdit_TabAttachFiles="true"
          :attachFiles="attachFiles"
          :attachFileDate="attachFileDate"
          :attachFilesType2="attachFilesType2"
          :attachFileDateType2="attachFileDateType2"
          :fileFormstatusModel="fileFormstatusModel"
          :fileFormstatusModelDates="fileFormstatusModelDates"
          :fileFormstatusType3Model="fileFormstatusType3Model"
          :fileFormstatusType3ModelDates="fileFormstatusType3ModelDates"
          :fileFormstatusType4Model="fileFormstatusType4Model"
          :fileFormstatusType4ModelDates="fileFormstatusType4ModelDates"
          @onAttachFileUploaded="onAttachFileUploaded"
          @onAttachFileDelete="onAttachFileDelete"
          :IsEditData="false"
        />
      </b-row>
    </b-col>
    <b-col cols="4">
      <b-card>
        <b-row>
          <h3 class="ml-2">ให้คำปรึกษา</h3>
          <b-col cols="12">
            <a :href="consultDocumentUrl" target="_blank" download
              ><feather-icon icon="FileIcon" class="mr-50" />
              เอกสารขอคำปรึกษา</a
            >
          </b-col>
          <b-col cols="12 mt-2">
            <b-form-group
              label="ความเห็นเจ้าหน้าที่"
              label-for="offficerComment"
            >
              <b-form-textarea
                id="offficerComment"
                placeholder="ความเห็นเจ้าหน้าที่"
                rows="20"
                v-model="lawConsult.detail"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12" class="d-flex justify-content-between mt-2">
            <!-- <b-button variant="secondary" @click="onBackBtnClicked">
            ยกเลิก
          </b-button> -->
            <b-button variant="primary" @click="onSubmitBtnClicked">
              บันทึก
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-col>

    <ModalDigitalId
      ref="modalDigitalIdComponent"
      :userId="currentUserIdModal"
      @handle-success="onModalDigitalIdSuccess"
    />

    <ModalCompany
      ref="modalCompanyComponent"
      :company="currentCompanyModal"
      @handle-submit="onBtnCompanySearchSubmit"
    />
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BCard,
  BFormRadio,
  BTab,
  BTabs,
  BButton,
  BListGroup,
  BListGroupItem,
  BFormGroup,
} from "bootstrap-vue";

import BCardActions from "@/@core/components/b-card-actions/BCardActions.vue";

import CompanyDetail from "../components/CompanyDetail.vue";
import CompanySearch from "../components/CompanySearch.vue";
import RightTab from "../components/RightTabAction.vue";

import TabAttachFiles from "../components/TabAttachFiles.vue";
import TabDocumentTrackingDetail from "../components/TabDocumentTrackingDetail.vue";

import LeftTab from "../components/LeftTabAction.vue";

import PersonDataDigital from "../components/PersonDataDigital.vue";
import ModalDigitalId from "../components/DigitalIdUserModal.vue";
import ModalCompany from "../components/ModalCompany.vue";
import ComplaintDetail from "../components/ComplaintDetail.vue";
import * as viewStore from "@/store/api/screening/screeningManage.js";
import * as complaintStore from "@/store/api/complaint/complaint.js";
import * as userStore from "@/store/api/user/index.js";
import * as lawConsultStore from "@/store/api/lawConsult/index.js";
import appsettings from "@/store/app-settings";

import * as userData from "@/auth/localStorageUtils.js";

export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    BListGroup,
    BListGroupItem,
    BCardActions,
    BFormGroup,
    RightTab,
    TabAttachFiles,
    TabDocumentTrackingDetail,
    viewStore,
    complaintStore,
    ModalDigitalId,
    ModalCompany,
    PersonDataDigital,
    CompanyDetail,
    CompanySearch,
    ComplaintDetail,
    userStore,
    LeftTab,
  },
  data() {
    return {
      personals: [],
      attorneys: [],
      complainantCompany: [],
      currentUserIdModal: "",
      currentCompanyModal: {},
      complaintData: {},
      complaintDetail: [],
      complaintDetailMultiSelect: [],
      masterIdList: [],
      complainId: null,
      levelId: null,
      attachFiles: [],
      attachFileDate: [],
      complaintCatagoryDetail: [],
      attachFilesType2: [],
      attachFileDateType2: [],
      fileFormstatusModel: [],
      fileFormstatusModelDates: [],
      fileFormstatusType3Model: [],
      fileFormstatusType3ModelDates: [],
      fileFormstatusType4Model: [],
      fileFormstatusType4ModelDates: [],
      document: {},
      lawConsult: {
        detail: "",
      },
      consultDocumentUrl: "",
    };
  },
  created() {
    const _this = this;
    if (this.$route.query.id == null) {
      const id = 1;
    } else {
      const qid = this.$route.query.docId;
      this.getDocument(qid);

      this.consultDocumentUrl =
        appsettings.documentComplaintUrl +
        "Download/DownloadByDoc?docId=" +
        qid +
        "&sarabunType=0";
    }
  },
  methods: {
    onSubmitBtnClicked() {
      const _this = this;

      this.$swal({
        title: "ยืนยันการบันทึกข้อมูล?",
        text: "",
        icon: "success",
        showCancelButton: true,
        confirmButtonText: "บันทึก",
        cancelButtonText: "ยกเลิก",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-primary ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          const data = {
            docId: _this.document.docId,
            complaintId: _this.document.complaintId,
            detail: _this.lawConsult.detail,
          };

          lawConsultStore
            .updateItem(data)
            .then((response) => {
              console.log("response", response);

              _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                variant: "success",
                solid: false,
              });
              this.$router.go(this.$router.currentRoute);
            })
            .catch((error) => {
              console.log("err", error);
            });
        }
      });
    },
    getDocument(id) {
      const _this = this;
      lawConsultStore.getDocumentByDocID(id).then((response) => {
        _this.document = response.data.data;

        _this.getComplaintById(_this.document.complaintId);
        _this.getLawConsultByDocumentId(id);
      });
    },
    getLawConsultByDocumentId(id) {
      const _this = this;
      lawConsultStore.getByDocId(id).then((response) => {
        if (response.data.data !== null) {
          _this.lawConsult = response.data.data;
        }
      });
    },
    getComplaintById(id) {
      const _this = this;
      //console.log('userData.userId', userData.userId())
      //console.log('userData.departmentId', userData.departmentId())
      complaintStore
        .getComplaintById(id)
        .then(function(response) {
          // handle success

          console.log("GetComplaintById", response);

          _this.personals = response.data.data.personals;
          _this.attorneys = response.data.data.attorneys;
          _this.complaintData = response.data.data.complaintModel;
          _this.complainantCompany = response.data.data.complainantCompany;
          _this.attachFiles = response.data.data.attachFiles;
          _this.attachFileDate = response.data.data.attachFileDate;
          _this.attachFilesType2 = response.data.data.attachFilesType2;
          _this.attachFileDateType2 = response.data.data.attachFileDateType2;
          _this.fileFormstatusModel = response.data.data.fileFormstatusModel;
          _this.fileFormstatusModelDates =
            response.data.data.fileFormstatusModelDates;
          _this.fileFormstatusType3Model =
            response.data.data.fileFormstatusType3Model;
          _this.fileFormstatusType3ModelDates =
            response.data.data.fileFormstatusType3ModelDates;
          _this.fileFormstatusType4Model =
            response.data.data.fileFormstatusType4Model;
          _this.fileFormstatusType4ModelDates =
            response.data.data.fileFormstatusType4ModelDates;
          _this.complaintDetail = response.data.data.complaintDetail;
          _this.complaintDetailMultiSelect =
            response.data.data.complaintDetailMultiSelect;
          _this.complaintCatagoryDetail =
            response.data.data.complaintCatagoryDetail;

          _this.complaintDetail.forEach((value, index) => {
            value.tmMasterList.forEach((value2, index2) => {
              if (value2.checked === true) {
                _this.masterIdList.push(value2.masterId);
              }
            });
          });

          const filterAttach = _this.attachFiles.filter((value) => {
            return value.createDateStr === _this.attachFileDate[0];
          });

          console.log(
            "_this.attachFileDate",
            _this.attachFileDate,
            filterAttach
          );
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
        });
    },
    onPersonDigitalEditClicked(userId) {
      this.currentUserIdModal = userId;
      this.$refs.modalDigitalIdComponent.$refs["modal-digital-id"].show();
    },
    onModalDigitalIdSuccess(id) {
      const _this = this;
      // need to get user id to update to view
      const currentUserId = id;
      this.currentUserIdModal = "";

      userStore
        .getById(currentUserId)
        .then(function(response) {
          // handle success
          console.log("userStore.getById", response);
          if (response.data.data !== null) {
            const person = response.data.data;

            const perIndex = _this.personals?.findIndex(function(value) {
              return value.userId === currentUserId;
            });

            const atIndex = _this.attorneys?.find(function(value) {
              return value.userId === currentUserId;
            });

            console.log("perIndex", perIndex, "atIndex", atIndex);

            if (perIndex >= 0 && perIndex != undefined) {
              _this.$set(_this.personals, perIndex, person);
            } else if (atIndex >= 0 && atIndex != undefined) {
              _this.$set(_this.attorneys, atIndex, person);
            } else {
              console.log(
                "personal",
                _this.personals,
                "attorneys",
                _this.attorneys
              );
              if (_this.modalMode === "personal") {
                //if (_this.personals === undefined) _this.personals = []
                _this.$set(_this.personals, _this.personals.length, person);
                //_this.personals.push(person)
              } else {
                //if (_this.attorneys === undefined) _this.attorneys = []
                _this.$set(_this.attorneys, _this.attorneys.length, person);
              }
              //console.log('personals', _this.personals, 'attorneys', _this.attorneys)
            }
          }

          //_this.$forceUpdate();
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
          _this.$refs.modalDigitalIdComponent.$refs["modal-digital-id"].hide();
        });
    },
    onBtnCompanySearchClicked(companyObj) {
      this.currentCompanyModal = companyObj;
      console.log("this.currentCompanyModal", this.currentCompanyModal);
      this.$refs.modalCompanyComponent.$refs["modal-company"].show();
    },
    onBtnCompanySearchDeleteClicked(companyObj) {
      console.log("onBtnCompanySearchDeleteClicked", companyObj);

      var filteredAry = this.complainantCompany.filter(
        (o) => o.compId != companyObj.compId
      );

      this.complainantCompany = filteredAry;
    },
    onBtnCompanySearchSubmit() {
      const _this = this;

      console.log("onBtnCompanySearchSubmit", this.currentCompanyModal);
      this.$refs.modalCompanyComponent.$refs["modal-company"].hide();

      const index = this.complainantCompany?.findIndex(function(value) {
        return value.compId === _this.currentCompanyModal.compId;
      });

      if (index >= 0) {
        _this.$set(_this.complainantCompany, index, _this.currentCompanyModal);
      } else {
        _this.$set(
          _this.complainantCompany,
          _this.complainantCompany.length,
          _this.currentCompanyModal
        );
      }
    },
    onComplaintBtnCancelClicked() {
      window.open(this.$router.resolve({ name: "Officer" }).href, "_self");
    },
    onComplaintBtnSubmitClicked() {
      const _this = this;

      this.$swal({
        title: "ยืนยันการบันทึกข้อมูล?",
        text: "",
        icon: "success",
        showCancelButton: true,
        confirmButtonText: "บันทึก",
        cancelButtonText: "ยกเลิก",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-primary ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          const data = {
            complaintModel: this.complaintData,
            personals: this.personals,
            attorneys: this.attorneys,
            attachFiles: this.attachFiles,
            complainantCompany: this.complainantCompany,
            userId: userData.userId(),
            complaintDetail: this.complaintDetail,
            complaintDetailMultiSelect: this.complaintDetailMultiSelect,
          };

          complaintStore
            .updateComplaint(data)
            .then((response) => {
              console.log("response", response);

              _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                variant: "success",
                solid: false,
              });

              // window.open(
              //   this.$router.resolve({ name: "Officer" }).href,
              //   "_self"
              // );
              this.$router.go(this.$router.currentRoute);
            })
            .catch((error) => {
              console.log("err", error);
            });

          //window.open(this.$router.resolve({ name: "Officer" }).href, "_self");
        }
      });
    },
    onAttachFileUploaded(file) {
      this.attachFiles.push(file);
    },
    onAttachFileDelete(id) {
      const file = this.attachFiles.find(function(value) {
        return value.attachId === id;
      });

      var filteredAry = this.attachFiles.filter((o) => o.attachId != id);

      this.attachFiles = filteredAry;
    },
    checkboxChanged(obj) {
      //console.log("obj", obj);
      if (obj.checked) {
        this.masterIdList.push(obj.masterId);
      } else {
        //uncheck
        this.masterIdList = this.masterIdList.filter((o) => {
          return o != obj.masterId;
        });

        //remove check ที่ masterTypeIdถัดๆไปทั้งหมด เมื่อมีการ uncheck ข้อมูล

        var notInside = [];
        //get remove list
        this.complaintDetail.forEach((o) => {
          if (obj.masterTypeId < o.masterTypeId) {
            o.tmMasterList.forEach((o2) => {
              notInside.push(o2.masterId);
            });
          }
        });

        //console.log("notInside:", notInside);
        this.masterIdList = this.masterIdList.filter((o) => {
          return !notInside.includes(o);
        });
        //end check
      }

      console.log("masterIdList:", this.masterIdList);

      var self = this;

      complaintStore
        .GetMasterTypeAll(this.masterIdList)
        .then(function(response) {
          console.log("response:", response);
          var dataList = response.data.data; //list รายการทั้งหมด
          //self.$refs.Step3Ref.refreshPage()

          //แสดงรายการ checkbox
          self.complaintDetail.forEach((o) => {
            o.tmMasterList = dataList.filter((o2) => {
              return o2.masterTypeId == o.masterTypeId;
            });
          });

          //ใส่ค่า check true
          self.complaintDetail.forEach((o) => {
            o.tmMasterList.forEach((o2) => {
              if (self.masterIdList.includes(o2.masterId)) {
                o2.checked = true;
              }
            });
          });
          self.$refs.Step3Ref.refreshPage();
        })
        .catch(function(error) {
          console.log("error", error);
        })
        .then(function() {});
      //console.log("checkboxChangeRoot: ", obj);
    },
  },
};
</script>

<style lang="scss"></style>
